<script setup>
import { ref } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import SummaryReports from './components/SummaryReports.vue';

const summaryReportsRef = ref(null);
</script>

<template>
  <ReportHeader
    :header-title="$t('BRANCH_REPORTS.HEADER')"
    :header-description="$t('BRANCH_REPORTS.DESCRIPTION')"
  />

  <SummaryReports
    ref="summaryReportsRef"
    action-key="summaryReports/fetchBranchSummaryReports"
    getter-key="branches/getBranches"
    fetch-items-key="branches/get"
    summary-key="summaryReports/getBranchSummaryReports"
    type="branch"
  />
</template>
